import React from "react";
import { useTranslation } from "react-i18next";
import holding from "../assets/figma/group-holding.svg";
import capital from "../assets/figma/group-capital.svg";
import fscc from "../assets/figma/group-fscc.png";
import suffix from "../assets/figma/group-spa-suffix.svg";
import wordmark from "../assets/figma/group-wordmark.svg";
import symbol from "../assets/figma/group-symbol.svg";

export default function GroupChart() {
  const { t } = useTranslation();
  return <div className="group-chart" role="img" aria-label={t("main.aboutUs.groupChartDescription")}>
    <div className="chart-root chart-box"><div className="chart-spa-logo">
      <img className="chart-spa-symbol" src={symbol} alt="" />
      <img className="chart-spa-wordmark" src={wordmark} alt="" />
      <img className="chart-spa-suffix" src={suffix} alt="" />
    </div></div>
    <div className="chart-branches" aria-hidden="true" />
    <div className="chart-holding chart-box"><img src={holding} alt="" /><span>100%</span></div>
    <div className="chart-fscc chart-box"><img src={fscc} alt="" /><span>24%</span></div>
    <div className="chart-capital chart-box"><img src={capital} alt="" /><span>100%</span></div>
  </div>;
}
